import { useGetGraphqlDataQuery, type UseQueryResult } from '@repo/services';
import { Select, type SelectProps } from 'antd';
import { getDealStatuses, type GetDealStatusesType } from 'crm-atoms/queries';
import { useMemo } from 'react';

export interface DealStatusSelectProps extends Omit<SelectProps, 'options' | 'onFocus'> {
  value?: string;
  onChange: (value: string) => void;
  withAnyOption?: boolean;
}

export default function DealStatusSelect({
  value,
  onChange,
  withAnyOption = false,
  ...props
}: DealStatusSelectProps) {
  const {
    data,
    isLoading,
  } = useGetGraphqlDataQuery<UseQueryResult<GetDealStatusesType>>({
    document: getDealStatuses,
  });

  const finalOptions = useMemo(() => {
    const options = data?.dealStatuses?.map(({ value: val, label }) => ({
      value: val,
      label,
    })) ?? [];

    if (withAnyOption) {
      options.unshift({ value: 'any', label: 'Any' });
    }

    return options;
  }, [data, withAnyOption]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={finalOptions}
      loading={isLoading}
      optionFilterProp="label"
      {...props}
    />
  );
}
